// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@/assets/css/base.css';
import '@/assets/css/tools.scss';
import '@/assets/css/iosSelect.css';
import '@/assets/css/1px.css';
import '@/assets/iconfont/iconfont.css';
import "@/assets/css/vant.scss";
import Vue from 'vue'
import App from './App'
import router from './router' //路由
import store from './utils/store' //使用vuex状态管理
import directives from './utils/directives' //通用方法
import client from './utils/client' //客户端交互方法
import tools from './utils/tools' //弹框
import request from './utils/request' //ajax请求
import axios from './utils/axios' //ajax请求
// import sensors from 'sa-sdk-javascript' //接入神策
import { wechatLogin } from "@/utils/wechat";
import { getwxsdkInfo, registerwxsdk } from "@/utils/wechatNew";
import {
  Popup,
  Picker,
  Dialog,
  RadioGroup,
  Radio,
  Field,
  Button,
  Cell,
  List,
  DatetimePicker,
  ActionSheet,
  Icon,
  Popover
} from "vant";
import '@/utils/sentry'

let nextRouterPath = '';

import VueScroller from 'vue-scroller'
Vue.use(Popover);
Vue.use(VueScroller)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(Dialog);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Field);
Vue.use(Button);
Vue.use(Cell);
Vue.use(List);
Vue.use(DatetimePicker);
Vue.use(ActionSheet);
Vue.use(Icon);

// import vConsole from 'vconsole';
// // 正式服不用
// if (!location.host.match(/yunrenshi|pugonganxin/)) {
//   var VConsole = new vConsole();
// }
Vue.use(directives);
Vue.use(client);

//接入神策初始化
// sensors.init({
//   server_url: 'https://sensorsdata.julanling.com:4006/sa?project=default&token=5RxKUT0sZQp9Lz5XgCCOd',
//   show_log: false // 关闭控制台不输出
// });
router.beforeEach((to, from, next) => {
  nextRouterPath = to.fullPath;
  // 过滤掉领取页的获取openid逻辑，
  // 领取页(cash, cashAll, myAccount)的微信是另外一个，需过滤掉默认登录逻辑
  if (
    to.fullPath.indexOf("/cash") === -1 &&
    to.fullPath.indexOf("/myAccount") === -1 &&
    to.fullPath.indexOf("/transitionPage") === -1 &&
    to.fullPath.indexOf("/transitionPageNew") === -1
  ) {
    wechatLogin(1, () => {
      next();
    }); // 获取openId
  } else {
    next();
  }

  Vue.nextTick(() => {
    // sensors.quick("autoTrackSinglePage", {
    //   platForm: "saas-staff"
    // });
  });
});
router.afterEach(() => {
  nextRouterPath = null
})

window._routerLoadError = () => {
  nextRouterPath && router.push(nextRouterPath)
}

//神策点位
Vue.prototype.setSensors = function (name, params) {
  let obj = {
    PlatformType: 'H5'
  }

  params = {
    ...obj,
    ...params
  }

  console.log(params)
  // try {
  //   sensors && sensors.track(name, params)
  // } catch (e) {

  // }
}

Vue.config.productionTip = false
Vue.config.ignoredElements = [
  'wx-open-launch-weapp'
]

Vue.prototype.$http = request;
Vue.prototype.$axios = axios;
Vue.prototype.showToast = tools.showToast.bind(tools);
Vue.prototype.showLoading = tools.showLoading.bind(tools);
Vue.prototype.showTxtLoading = tools.showTxtLoading.bind(tools);
Vue.prototype.hideLoading = tools.hideLoading.bind(tools);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  beforeMount () {
    if (
      location.href.split("#") &&
      location.href.split("#")[1] &&
      (location.href.split("#")[1] === "/transitionPage" ||
        location.href.split("#")[1] === "/transitionPageNew")
    ) {
      //过渡页不注册微信，过渡页里面有
      return;
    }
      getwxsdkInfo().then(res => {
        console.log(res, "res===");
        registerwxsdk(res);
      });
  },
  // components: {
  //   App
  // },
  // template: '<App/>'
  render: h => h(App)
})
